export function getTokenExpiryMs(token) {
    if (!token || typeof token !== "string") {
        return null;
    }

    try {
        const payloadPart = token.split(".")[1];
        if (!payloadPart) {
            return null;
        }
        const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(atob(normalized));
        return typeof payload.exp === "number" ? payload.exp * 1000 : null;
    } catch {
        return null;
    }
}

export function isTokenExpired(token, skewMs = 30_000) {
    const expiryMs = getTokenExpiryMs(token);
    if (!expiryMs) {
        return false;
    }
    return Date.now() >= expiryMs - skewMs;
}

export function msUntilTokenExpiry(token, skewMs = 60_000) {
    const expiryMs = getTokenExpiryMs(token);
    if (!expiryMs) {
        return null;
    }
    return expiryMs - skewMs - Date.now();
}
